import React, { createContext, useContext, useReducer } from 'react'

import { DEFAULT_TEMPLATE } from '../modules/templates/templateEditor/defaultTemplate'
import { Action } from '../modules/templates/templateEditor/editorActions'
import { TemplateData } from '../modules/templates/types/blueprint'

import { reducer, EditorState } from './templateEditorReducer'

import {
  LibraryTemplate,
  LibraryTemplateUiQuery,
  Template,
  TemplateType,
  TemplateUiQuery,
} from 'types/api.graphql'

type Value = {
  id: string
  template: TemplateData
  dispatch: React.Dispatch<Action>
  editingItem: EditorState['editingItem']
  templateType: TemplateType
  isEmptyTemplate: boolean
  templateName: string
}

type Props = {
  templateOrLibraryTemplate:
    | LibraryTemplate
    | Template
    | TemplateUiQuery['template']
    | LibraryTemplateUiQuery['libraryTemplate']
  children?: React.ReactNode
}

export const EditorContext = createContext<Value>(null)

export const EditorProvider: React.FC<Props> = ({
  children,
  templateOrLibraryTemplate,
}) => {
  const [editorState, dispatch] = useReducer(reducer, {
    template: templateOrLibraryTemplate.templateData || DEFAULT_TEMPLATE,
    editingItem: null,
  })

  const { template, editingItem } = editorState

  const isEmptyTemplate = !template?.sections?.some((s) =>
    s.blockGroups?.some((bg) => bg.blocks?.length > 0)
  )

  const value = {
    id: templateOrLibraryTemplate.id,
    template,
    dispatch,
    editingItem,
    templateName: templateOrLibraryTemplate.templateName,
    templateType: templateOrLibraryTemplate.templateType,
    isEmptyTemplate,
  }

  return (
    <EditorContext.Provider value={value}>{children}</EditorContext.Provider>
  )
}

export const useTemplateEditor = () => useContext(EditorContext)
